const messageLevels = {
	ERROR: "error",
	INFO: "info",
	SUCCESS: "success"
};

export default messageLevels;